import { render, staticRenderFns } from "./BaseAddressAutoComplete.vue?vue&type=template&id=63023a79&lang=pug&"
import script from "./BaseAddressAutoComplete.vue?vue&type=script&lang=js&"
export * from "./BaseAddressAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports